import { injectIntl } from "react-intl";
import React from "react";
import { CalendarType } from "src/helpers/Enums";

const Header = (props) => {

    return (
        <div className={ "PageHeader" }>
            <div className={ "PageHeaderTitle" }>
                All Calendar
            </div>
            <div className={ "flex gap-3" }>
                <div className={ "CalendarTypeBox" }>
                    <button onClick={ () => props.handleType(CalendarType.Calendar) }
                            className={ props.type === CalendarType.Calendar ? "CalendarTypeChosenButton" : "CalendarTypeButton" }>{ CalendarType.Calendar }
                        { props.type === CalendarType.Calendar && <span className={ "ChosenMarkerListType" }></span> }
                    </button>
                    <img alt={ "Logo" } src={ "/media/icons/separate.png" } className={ "h-[22px] w-[1px]" }/>
                    <button onClick={ () => props.handleType(CalendarType.List) }
                            className={ props.type === CalendarType.List ? "CalendarTypeChosenButton" : "CalendarTypeButton" }>{ CalendarType.List }
                        { props.type === CalendarType.List && <span className={ "ChosenMarkerListType" }></span> }
                    </button>
                </div>
                <button className={ "PrimaryButton" } onClick={ () => props.setOpenNewSchedule(true) }>
                    <img alt={ "Logo" } src={ "/media/icons/plusIcon.svg" } className={ "w-4 h-4" }/>
                    New Schedule
                </button>
            </div>
        </div>
    )
}

export default injectIntl(Header);